import { render } from "./NavBar.vue?vue&type=template&id=4b8768a0&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=4b8768a0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b8768a0"

export default script